export default class Homepage {
    constructor() {
        this.data = document.getElementById("homepageData");
        this.today = document.getElementById("today");

        if (this.today) {
            this.heightSummary = this.today.offsetHeight;
            this.heightBlocReport = document.getElementById("overall").parentNode.offsetHeight;
        }

        if (this.data) {
            this.loader = document.getElementById("loader");
            this.currentTarget = undefined;
            this.summary = undefined;

            this.tab = {
                link: undefined,
                element: undefined,
            };

            this.refreshPageChunk = this.refreshPageChunk.bind(this);
            this.setErrorMessage = this.setErrorMessage.bind(this);
            this.bind();
            this.bindQRCode();
        }
    }

    setPageChunk(data) {
        this.tab.element.innerHTML = data;
        this.loader.classList.add("d-n");
        this.data.appendChild(this.loader);
        this.tab.element.classList.remove("d-n");
    }

    toggleTab(target) {
        Array.from(this.tab.element.parentNode.children).forEach((child) => {
            if (target.href.indexOf(child.id) === -1) {
                child.classList.add("d-n");
            } else {
                child.classList.remove("d-n");
            }
        });
    }

    setErrorMessage() {
        this.loader.innerHTML = this.data.dataset.error;
    }

    refreshPageChunk() {
        this.summary = this.currentTarget.classList.contains("summary");
        this.tab.link = this.currentTarget.getAttribute("href");

        this.tab.element = document.querySelector(this.currentTarget.getAttribute("href"));
        if (!this.tab.element.hasChildNodes()) {
            this.toggleTab(this.currentTarget);
            this.tab.element.classList.add("d-n");
            this.tab.element.parentNode.appendChild(this.loader);

            this.loader.classList.remove("d-n");
            this.loader.style.height = `${this.summary ? this.heightSummary : this.heightBlocReport}px`;

            const homepageObject = this;
            const request = new XMLHttpRequest();
            request.onreadystatechange = function onreadystatechange() {
                if (this.readyState === XMLHttpRequest.DONE) {
                    if (this.status === 200) {
                        homepageObject.setPageChunk(this.responseText);
                    } else {
                        homepageObject.setErrorMessage(this.statusText);
                    }
                }
            };
            request.open("POST", this.currentTarget.dataset.href, true);
            request.send(null);
        } else {
            this.toggleTab(this.currentTarget);
        }
    }

    bind() {
        document.querySelector("main").addEventListener("click", (event) => {
            if (event.target.classList.contains("js-dfs-ajax")) {
                this.currentTarget = event.target;
                this.refreshPageChunk();
            }
        });
    }

    bindQRCode() {
        document.querySelector("main").addEventListener("click", (event) => {
            if (!event.target.classList.contains("js-dfs-ajax-link")) {
                return;
            }

            event.preventDefault();

            fetch(event.target.getAttribute("href"), {
                credentials: "include",
                method: "post",
            }).then((response) => {
                if (response.ok) {
                    return;
                }
                throw new Error("Network response was not ok.");
            }).catch((error) => {
                console.log("There has been a problem with your fetch operation: ", error.message);
            });
        });
    }
}
